import type { ReactNode } from 'react';

import { Navigate } from 'react-router';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuth } from './auth-context';

// ----------------------------------------------------------------------
// Guards de rota. AuthGuard protege o dashboard (sem sessão → /login).
// GuestGuard mantém quem já está logado fora do /login (→ Início).
// Enquanto a sessão é validada (/auth/me), mostra o SplashScreen do Minimal.
// ----------------------------------------------------------------------

export function AuthGuard({ children }: { children: ReactNode }) {
  const { authenticated, loading } = useAuth();

  if (loading) return <SplashScreen />;
  if (!authenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function GuestGuard({ children }: { children: ReactNode }) {
  const { authenticated, loading } = useAuth();

  if (loading) return <SplashScreen />;
  if (authenticated) return <Navigate to="/" replace />;
  return <>{children}</>;
}
